export function normalizarMsisdn(valor: unknown) {
  let digitos = String(valor ?? '').replace(/\D/g, '');
  if (digitos.length === 12 && !digitos.startsWith('55') && digitos[2] === '9' && digitos[3] === '9') {
    digitos = `${digitos.slice(0, 2)}${digitos.slice(3)}`;
  }
  return (digitos.length === 12 || digitos.length === 13) && digitos.startsWith('55')
    ? digitos.slice(2)
    : digitos;
}
